// extracted by mini-css-extract-plugin
export default {"table":"components-hotel-channel-pricing-tables-channels-table-module__table","channels-table":"components-hotel-channel-pricing-tables-channels-table-module__channels-table"};